<template>
    <node-view-wrapper :class="['structure-block', { 'selected': selected }]" data-structure-block="content">
        <span class="fake-field-label required q-mb-xs" contenteditable="false">{{ $tc('common.term.content', 1) }}</span>

        <!-- TODO @TFU: Add `.has-focus` class to node-view-content element when it is active (document.activeElement)  -->
        <node-view-content
            :class="['structure-block-content', { 'is-empty': !hasContent, 'has-error': (validation.$error && !validation.required) }]"
            :data-placeholder="schemaType ? $t(`common.editor.structure-block.content.placeholder--${schemaType}`) : $t('common.editor.structure-block.content.placeholder')"
        />

        <p v-if="validation.$error && !validation.required" class="error-message" contenteditable="false">{{ $tc('common.error-message.required', 1, { field: $tc('common.term.content', 1) }) }}</p>
    </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-2'

export default {
    name: 'StructureBlockContentNodeView',
    components: {
        NodeViewWrapper,
        NodeViewContent,
    },
    props: nodeViewProps,
    computed: {
        validation () {
            return (this.editor.$v) ? this.editor.$v[this.editor.schema.nodes.structureBlock_content.name] ?? {} : {}
        },
        hasContent () {
            return this.node.content.size > 2 // As the structureBlockContent extension will always force an empty paragraph to exist, the threshold we use to check if it has content is actually 2.
        },
        schemaType () {
            return this.editor.schema.spec.topNode
        },
    },
}
</script>
